import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { CheckLg } from 'react-bootstrap-icons'
import { FaCheck } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const Packages = () => {
    const { t } = useLanguage();

    // Helper function to safely map over translation arrays
    const safeMap = (translationArray, mapFunction) => {
        if (!Array.isArray(translationArray)) {
            return [];
        }
        return translationArray.map(mapFunction);
    };

    const pkg = [
        {
            id: '1',
            heading: t('packages.graphicDesigning.heading') || 'Graphic Designing',
            title: t('packages.graphicDesigning.logoDesign.title') || 'Logo Design',
            title1: t('packages.graphicDesigning.branding.title') || 'Branding',
            value: '165',
            value1: '411',
            desc1: safeMap(t('packages.graphicDesigning.logoDesign.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.graphicDesigning.branding.features'), feature => ({ description2: feature })),
        },
        {
            id: '2',
            heading: t('packages.graphicDesigning.heading') || 'Graphic Designing',
            title: t('packages.graphicDesigning.animation.title') || 'Animation',
            title1: t('packages.graphicDesigning.stationery.title') || 'Stationery',
            value: '215',
            value1: '153',
            desc1: safeMap(t('packages.graphicDesigning.animation.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.graphicDesigning.stationery.features'), feature => ({ description2: feature })),
        },
        {
            id: '3',
            heading: t('packages.webDevelopment.heading') || 'Web Development',
            title: t('packages.webDevelopment.customized.title') || 'Customized',
            title1: t('packages.webDevelopment.eCommerce.title') || 'E-Commerce',
            value: '614',
            value1: '1229',
            desc1: safeMap(t('packages.webDevelopment.customized.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.webDevelopment.eCommerce.features'), feature => ({ description2: feature })),
        },
        {
            id: '4',
            heading: t('packages.contentWriting.heading') || 'Content Writing',
            title: t('packages.contentWriting.blogWriting.title') || 'Blog Writing',
            title1: t('packages.contentWriting.creativeScriptwriting.title') || 'Creative Scriptwriting',
            value: '42',
            value1: '79',
            desc1: safeMap(t('packages.contentWriting.blogWriting.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.contentWriting.creativeScriptwriting.features'), feature => ({ description2: feature })),
        },
        {
            id: '5',
            heading: t('packages.contentWriting.heading') || 'Content Writing',
            title: t('packages.contentWriting.websiteContent.title') || 'Website Content',
            title1: t('packages.contentWriting.articleWriting.title') || 'Article Writing',
            value: '245',
            value1: '122',
            desc1: safeMap(t('packages.contentWriting.websiteContent.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.contentWriting.articleWriting.features'), feature => ({ description2: feature })),
        },
        {
            id: '6',
            heading: t('packages.socialMedia.heading') || 'Social Media',
            title: t('packages.socialMedia.socialMediaMarketing.title') || 'Social Media Marketing',
            title1: t('packages.socialMedia.youtubeMarketing.title') || 'YouTube Marketing',
            value: '307',
            value1: '245',
            desc1: safeMap(t('packages.socialMedia.socialMediaMarketing.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.socialMedia.youtubeMarketing.features'), feature => ({ description2: feature })),
        },
        {
            id: '7',
            heading: t('packages.socialMedia.heading') || 'Social Media',
            title: t('packages.socialMedia.emailMarketing.title') || 'Email Marketing',
            title1: t('packages.socialMedia.googleMyBusiness.title') || 'Google My Business',
            value: '245',
            value1: '165',
            desc1: safeMap(t('packages.socialMedia.emailMarketing.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.socialMedia.googleMyBusiness.features'), feature => ({ description2: feature })),
        },
        {
            id: '8',
            heading: t('packages.seo.heading') || 'SEO',
            title: t('packages.seo.assessmentTechnical.title') || 'Assessment & Technical',
            title1: t('packages.seo.onPageOffPage.title') || 'On-Page & Off-Page',
            value: '411',
            value1: '411',
            desc1: safeMap(t('packages.seo.assessmentTechnical.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.seo.onPageOffPage.features'), feature => ({ description2: feature })),
        },
        {
            id: '9',
            heading: t('packages.paidMarketing.heading') || 'Paid Marketing',
            title: t('packages.paidMarketing.googleAdsManagement.title') || 'Google Ads Management',
            title1: t('packages.paidMarketing.facebookInstagramAds.title') || 'Facebook & Instagram Ads Management',
            value: '245',
            value1: '245',
            desc1: safeMap(t('packages.paidMarketing.googleAdsManagement.features'), feature => ({ description1: feature })),
            desc2: safeMap(t('packages.paidMarketing.facebookInstagramAds.features'), feature => ({ description2: feature })),
        },
    ]
    return (
        <div id='website-responsive'>
            <div className='left-padding8rem right-padding8rem '>
                <div className='left-padding7rem1 right-padding7rem1 py-md-5 py-4'>

                    {/* <> */}

                    {/* {pkg.map((pkg, i) => ( */}

                    <>
                        <div className='text-align-center1 pt-4 pt-lg-0 pt-md-3'>
                            <h2 className='fs-ss-32 fw-900 text-mulish'>
                                {t('packages.graphicDesigning.heading')}<span className='text-ss-primary'> {t('packages.title')} </span>
                            </h2>
                        </div>

                        <Row className='mb-lg-5 pb-lg-5 mb-4 pb-4'>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch dgrid' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.graphicDesigning.logoDesign.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>€</span>
                                        <span className='fs-ss-32 text-mulish fw-800 text-ss-primary'>165</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc1.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature1')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature2')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature3')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature4')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature5')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature6')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature7')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>{t('packages.graphicDesigning.logoDesign.feature8')}</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.graphicDesigning.branding.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>€</span>
                                        <span className='fs-ss-32 text-mulish fw-800 text-ss-primary'>411</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc2.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>4 Custom Logo Design concepts</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Dedicated Designers</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Stationary Design Set</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Flyer</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>3 Pages Website</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>6 Copyright Images</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>3 Social Media Pages Creation</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>4 Banner Designs</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Deliver in 2 Weeks</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Satisfaction Guarantee</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                            <Col lg='6' className='mt-lg-5 mt-4' >
                                <div className='m-4 p-4 card-stretch dgrid' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.graphicDesigning.animation.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>{t('packages.graphicDesigning.animation.price')}</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc1.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>2D / Whiteboard / Explainer animation videos</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Video</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Up-to 1 minute Video</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Script writing</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Finalized & Published</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Deliver in 4 Days</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% ownership rights</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Satisfaction</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                            <Col lg='6' className='mt-lg-5 mt-4' >
                                <div className='m-4 p-4 card-stretch' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.graphicDesigning.stationery.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>{t('packages.graphicDesigning.stationery.price')}</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc2.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>2 Business Card Design</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Letterhead Design</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Flyer Design / 1 Brochure Design</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Dedicated Designer</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>All File Formats</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>3 Free Revisions</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Deliver in 48 Hours</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Satisfaction
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>
                        </Row>


                        <div className='text-align-center1 pt-4 pt-lg-0 pt-md-3'>
                            <h2 className='fs-ss-32 fw-900 text-mulish'>
                                {t('packages.webDevelopment.heading')}<span className='text-ss-primary'> {t('packages.title')} </span>
                            </h2>
                        </div>

                        <Row className='mb-lg-5 pb-lg-5 mb-4 pb-4'>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch dgrid' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.webDevelopment.customized.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>{t('packages.webDevelopment.customized.price')}</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc1.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>7-8 Web Pages</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>1 Basic Contact / Inquiry Form</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Mobile Friendly Website</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Image Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Speed Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>WhatsApp & Facebook Chat Integration</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Social Media Linking</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>FREE up to 20 Stock Photos</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Website Testing
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Google Tools Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Basic SEO setup
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Google Friendly Sitemap
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Delivery in 10-20 Working Days
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Unique Design

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Unique Content

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>100% Client Satisfaction
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />


                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.webDevelopment.eCommerce.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>{t('packages.webDevelopment.eCommerce.price')}</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    {/* {pkg.desc2.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>7 Static Pages</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Up to 15 Categories & 150 Products</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>2 Basic Contact / Inquiry Form
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Newsletter Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Free up to 20 Stock images</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Shopping Cart Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Professionally written</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Payment Gateway (Stripe & PayPal)
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Customer's Login Area
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Dedicated User Roles

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Image & Speed Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>WhatsApp & Facebook Chat Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Mobile Friendly Website
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Website Testing

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Google Tools Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Basic SEO setup

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Google Friendly Sitemap

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Delivery in 4-6 Weeks

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />


                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>
                        </Row>

                        <div className='text-align-center1 pt-4 pt-lg-0 pt-md-3'>
                            <h2 className='fs-ss-32 fw-900 text-mulish'>
                                {t('packages.seo.heading')}<span className='text-ss-primary'> {t('packages.title')} </span>
                            </h2>
                        </div>
                        <div className='d-flex justify-content-center align-items-center'>
                            <span className='fs-ss-18 text-mulish fw-800 text-ss-primary lh-1'>Starting From €</span>
                            <span className='fs-ss-32 text-mulish fw-800 text-ss-primary mx-1'> 411</span>
                            <span className='fs-ss-15 text-lato fw-500'> / month</span>
                        </div>

                        <Row className='pb-lg-5 mb-lg-5 mb-4'>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch dgrid' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.seo.assessmentTechnical.title')}

                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />


                                    {/* <hr className='mt-1' style={{ opacity: 0.1 }} /> */}

                                    {/* {pkg.desc1.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Competitors Analysis</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Audit Before Starting Project</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Technical Optimization</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Content Audit
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Page Speed Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Redirects Audit / Fix Broken Links 404</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Secure website with HTTPS</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>XML Sitemap Creation & Submission</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Robots.txt Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>URL structures Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Internal Linking
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Google Analytics, Search Console & Tag Manager Integration
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />



                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                            <Col lg='6' className='mb-lg-0 mb-4 pb-lg-0 pb-md-4' >
                                <div className='m-4 p-4 card-stretch' style={{ boxShadow: '0px 2px 12px 2px rgba(0, 0, 0, 0.4)', borderWidth: '4px 0px 0px 0px', borderStyle:'solid', borderColor:'rgba(9,9,9,.1)'  }}>
                                    <div className=''>
                                        <h2 className='fs-ss-30 text-lato fw-700'>
                                            {t('packages.seo.onPageOffPage.title')}
                                        </h2>
                                    </div>

                                    <hr className='' style={{}} />

                                    {/* <div className=''>
                                        <span className='fs-ss-22 text-mulish fw-800 text-ss-primary'>Starting From CAD$ </span>
                                        <span className='fs-ss-32 text-mulish fw-800 text-ss-primary'>1,999</span>
                                    </div>

                                    <hr className='mt-1' style={{ opacity: 0.1 }} /> */}

                                    {/* {pkg.desc2.map((descr)=>( */}
                                    <>
                                        <div className=''>
                                            <b className='fs-ss-18 fw-bold text-mulish'>On - Page Optimization</b>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Keyword Research
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Targeting 10 - 20 Keywords</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Up to 10 Pages Optimization
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Title ,Tags & Meta descriptions
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Alt tags Optimization</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Mobile - Friendliness
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <b className='fs-ss-18 text-mulish fw-bold'>Off - Page Optimization</b>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Local Business Listings</span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Social Bookmarking

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Customer's Login Area
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Relevant Link Building

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Article Submission

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Guest Posting

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Reporting (Weekly - Monthly)
                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />
                                        <div className=''>
                                            <FaCheck className='me-2 text-ss-primary' />
                                            <span className='fs-ss-14 text-mulish fw-500'>Support (Email - Phone)

                                            </span>
                                        </div>
                                        <hr className='mt-1' style={{ opacity: 0.1 }} />

                                    </>
                                    {/* ))} */}

                                    <div className='d-flex justify-content-center mt-lg-5 mt-4'>
                                    <Link to='/packages-form' style={{ textDecoration:'none'}}>
                                        <Button className='btn-ss-package'>
                                            CHOOSE PLAN
                                        </Button>
                                    </Link>
                                    </div>
                                </div>

                            </Col>

                        </Row>
                    </>
                </div>
            </div>
        </div>

    )
}

export default Packages